/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on all pages

    /**
     * General helper function to support toggle functions.
     */
    var toggleClasses = function(element) {
      var $this = element,
          $togglePrefix = $this.data('prefix') || 'this';

      // If the element you need toggled is relative to the toggle, add the
      // .js-this class to the parent element and "this" to the data-toggled attr.
      if ($this.data('toggled') == "this") {
        var $toggled = $this.closest('.js-this');
      }
      else {
        var $toggled = $('.' + $this.data('toggled'));
      }
      if ($this.attr('aria-expanded', 'true')) {
        $this.attr('aria-expanded', 'true')
      }
      else {
        $this.attr('aria-expanded', 'false')
      }
      $this.toggleClass($togglePrefix + '-is-active');
      $toggled.toggleClass($togglePrefix + '-is-active');

      // Remove a class on another element, if needed.
      if ($this.data('remove')) {
        $('.' + $this.data('remove')).removeClass($this.data('remove'));
      }
    };

    /*
     * Toggle Active Classes
     *
     * @description:
     *  toggle specific classes based on data-attr of clicked element
     *
     * @requires:
     *  'js-toggle' class and a data-attr with the element to be
     *  toggled's class name both applied to the clicked element
     *
     * @example usage:
     *  <span class="js-toggle" data-toggled="toggled-class">Toggler</span>
     *  <div class="toggled-class">This element's class will be toggled</div>
     *
     */
    $('.js-toggle').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    var mobileNav = function() {
      if(window.innerWidth>1099) {
        document.querySelector('.c-menu__child-list').style = '';
        document.querySelector('.c-menu .o-menu-arrow').classList.remove('this-is-active');
        document.querySelector('.c-menu .o-hamburger').classList.remove('this-is-active');
      } else {
        document.querySelector('.c-menu__child-list').style.visibility = 'visible';
        document.querySelector('.c-menu__child-list').style.opacity = '1';
      }
    }

    window.addEventListener('resize', function(e) {
      mobileNav();
    });

    window.addEventListener('load', function(e) {
      mobileNav();
    });

    window.addEventListener("orientationchange", function(e) {
      setTimeout(function() {
        mobileNav();
      }, 2);
    });

    // Toggle parent class
    $('.js-toggle-parent').on('click', function(e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('this-is-active');
      $this.parent().toggleClass('this-is-active');
    });

    // Toggle mobile menu to close on desktop
    // Note: not closing on mobile
    window.addEventListener('resize', function(e) {
      if(window.innerWidth>1099) {
        document.querySelector('.c-menu .c-menu--list').style.display = 'flex';
      } else {
        document.querySelector('.c-menu .c-menu--list').style.display = '';
      }
    });

    // Prevent bubbling to the body. Add this class to the element (or element
    // container) that should allow the click event.
    $('.js-stop-prop').on('click', function(e) {
      e.stopPropagation();
    });

    // Toggle hovered classes
    $('.js-hover').on('mouseenter mouseleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleClasses($(this));
    });

    $('.js-hover-parent').on('mouseenter mouseleave', function(e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('this-is-active');
      $this.parent().toggleClass('this-is-active');
    });

    MicroModal.init({
      disableScroll: true,
      awaitCloseAnimation: true,
      openTrigger: 'data-custom-open',
      closeTrigger: 'data-custom-close'
    });

    // Parallax elements
    var scene1 = document.getElementById('scene1');
    if (scene1) {
      var parallaxInstance = new Parallax(scene1);
    }
    var scene2 = document.getElementById('scene2');
    if (scene2) {
      var parallaxInstance = new Parallax(scene2);
    }
    var scene3 = document.getElementById('scene3');
    if (scene3) {
      var parallaxInstance = new Parallax(scene3);
    }
    var scene4 = document.getElementById('scene4');
    if (scene4) {
      var parallaxInstance = new Parallax(scene4);
    }
    var scene5 = document.getElementById('scene5');
    if (scene5) {
      var parallaxInstance = new Parallax(scene5);
    }
    var scene6 = document.getElementById('scene6');
    if (scene6) {
      var parallaxInstance = new Parallax(scene6);
    }

    // Nav BG Transition
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 55) {
        $('#mainHeader').css('background-color','#000');
      } else {
        $('#mainHeader').css('background-color','transparent');
      }
    });

    // Swiper Carousel
    var swiper = new Swiper("#aboutCarousel", {
      slidesPerView: 2,
      spaceBetween: 30,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
          spaceBetween: 40
        }
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        //dragSize: '10', // this just changes the width of the scrollbar itself
        draggable: true,
        observer: true,
        observeSlideChildren: true,
        resizeObserver: true,
      },
    });

    // Waypoints
    $(document).ready(function(){
      $('.is-animated--hide').waypoint(function (direction) {
        if (direction === 'down') {
          // Fade In   
          if ($(this.element).hasClass('fade-in')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in');
          }
          if ($(this.element).hasClass('fade-in--T')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--T');
          }
          if ($(this.element).hasClass('fade-in--T--half')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--T--half');
          }
          if ($(this.element).hasClass('fade-in--B')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--B');
          }
          if ($(this.element).hasClass('fade-in--B--half')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--B--half');
          }
          if ($(this.element).hasClass('fade-in--L')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--L');
          }
          if ($(this.element).hasClass('fade-in--L--half')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--L--half');
          }
          if ($(this.element).hasClass('fade-in--R')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--R');
          }
          if ($(this.element).hasClass('fade-in--R--half')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--R--half');
          }
          if ($(this.element).hasClass('fade-in--TL')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--TL');
          }
          if ($(this.element).hasClass('fade-in--TR')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--TR');
          }
          if ($(this.element).hasClass('fade-in--BL')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--BL');
          }
          if ($(this.element).hasClass('fade-in--BR')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-in--BR');
          }

          // Fade In Then Slide
          if ($(this.element).hasClass('fade-then-slide--T-BL')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-then-slide--T-BL');
          }
          if ($(this.element).hasClass('fade-then-slide--T-BR')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--fade-then-slide--T-BR');
          }

          // Slide In
          if ($(this.element).hasClass('slide-in--U')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--slide-in--U');
          }
          if ($(this.element).hasClass('slide-in--D')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--slide-in--D');
          }
          if ($(this.element).hasClass('slide-in--L')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--slide-in--L');
          }
          if ($(this.element).hasClass('slide-in--R')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--slide-in--R');
          }

          // Our Platform section
          if ($(this.element).hasClass('item-top')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--item-top');
          }
          if ($(this.element).hasClass('item-right')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--item-right');
          }
          if ($(this.element).hasClass('item-left')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--item-left');
          }
          if ($(this.element).hasClass('slide-TL-back')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--item-slide-TL-back');
          }
          if ($(this.element).hasClass('slide-BR-back')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--item-slide-BR-back');
          }
          if ($(this.element).hasClass('slide-BL-back')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--item-slide-BL-back');
          }
          if ($(this.element).hasClass('o-icon--slash-1')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated');
          }
          if ($(this.element).hasClass('o-icon--slash-2')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated');
          }
          if ($(this.element).hasClass('o-icon--slash-3')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated');
          }
          if ($(this.element).hasClass('anim-wrap')) {
            $(this.element).removeClass('is-animated--hide').addClass('is-animated is-animated--anim-wrap');
          }
        }
      }, { offset: '95%' });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js